module.exports = __webpack_public_path__ + "img/Frame1321314813@2x.e44ad135.png";